import { routes as taskCode } from "./crud/taskCode";
import { routes as customers } from "./crud/customer";
import { routes as adminUsers } from "./crud/adminUser";
import { routes as orgStructure } from "./crud/orgStructure";
import { routes as partiallyMatchedEmployees } from "./partiallyMatchedEmployees";
import { routes as triages } from "./triage/routes";
import { routes as qaAuditQueue } from "./qaAuditQueue/routes";
import { routes as bookAppointments } from "./bookAppointments";
import { routes as diaries } from "./diaries/routes";
import { routes as teams } from "./teams";
import { routes as calendar } from "./calendar";
import { routes as rooms } from "./crud/room";
import { routes as actionableTasks } from "./actionableTasks";
import { routes as taskManagement } from "./taskManagement/routes";
import { routes as ppqs } from "./ppq";
import { routes as textSnippets } from "./crud/textSnippet";
import { routes as immunisationTypes } from "./crud/immunisationType";
import { routes as customerCategories } from "./crud/customerCategories";
import { routes as dataExtracts } from "./dataExtracts";
import { routes as sraCustomers } from "./crud/sraCustomer";
import { routes as genericCaseTypes } from "./genericCaseTypes";
import { routes as importTool } from "./importTool";
import { routes as searchUsers } from "./searchUsers";
import { ADMIN_ROLES } from "./auth";
import { routes as selfServiceCheckIn } from "./selfServiceCheckIn";
import { routes as fastTrackPitPupMedicalForm } from "./fastTrackPitPupMedicalForm";
import { routes as eventLog } from "./eventLog/routes";
import { routes as allTasks } from "./allTasks/routes";
import { routes as emailTemplates } from "./crud/emailTemplates/routes";
import { routes as accessGroups } from "./accessGroups";
import { routes as customMedicalTypes } from "./customMedicalTypes";
import { routes as genericCaseForm } from "./genericCases/genericCaseForm/routes";
import { routes as sncRules } from "./sncRules/routes";
import { routes as manageFeatureToggles } from "./manageFeatureToggles/routes";

export const routes: any = {
    "/": {
        title: "Home",
        authorize: false
    },
    "/referral/:customerId/:questionnaireId": {
        title: "Referral",
        authorize: true
    },
    "/physiotherapyreferral/:customerId/:referralId": {
        title: "Physiotherapy Referral",
        authorize: true
    },
    "/customer/:customerId/case/:ohCaseId/referral": {
        title: "Referral",
        authorize: [ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name]
    },
    "/customer/:customerId/case/:ohCaseId/physiotherapyreferral": {
        title: "Physiotherapy Referral",
        authorize: [ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name]
    },
    "/customers/:customerId/employeeRecords/:employeeRecordId/ohCases/:ohCaseId/:taskId/iaptViewCompletedQuestionnaire": {
        title: "IAPT Completed Questionnaire",
        authorize: true
    },
    ...triages,
    ...qaAuditQueue,
    ...bookAppointments,
    ...diaries,
    ...customers,
    ...taskCode,
    ...adminUsers,
    ...orgStructure,
    ...partiallyMatchedEmployees,
    ...teams,
    ...accessGroups,
    ...customMedicalTypes,
    ...calendar,
    ...rooms,
    ...actionableTasks,
    ...taskManagement,
    ...ppqs,
    ...textSnippets,
    ...immunisationTypes,
    ...customerCategories,
    ...dataExtracts,
    ...sraCustomers,
    ...genericCaseTypes,
    ...importTool,
    ...selfServiceCheckIn,
    ...fastTrackPitPupMedicalForm,
    ...eventLog,
    ...allTasks,
    ...emailTemplates,
    ...searchUsers,
    ...genericCaseForm,
    ...sncRules,
    ...manageFeatureToggles,
};
